export default __webpack_public_path__ + "static/media/Zoom.9a9e303e.svg";